<template>
  <div>
    <div class="d-sm-flex align-items-center justify-content-between mb-4">
      <h1 class="h3 mb-0 text-gray-800">Dashboard</h1>
    </div>

    <div class="row">
      <!-- crad started -->
      <div
        class="col-xl-3 col-md-6 col-sm-12 mb-4"
        v-for="(n, i) in data"
        :key="i"
      >
        <div :class="`card border-left-${n.theme} shadow h-100 py-2`">
          <div class="card-body">
            <router-link class="routerLink nav-link" to="#">
              <div class="row no-gutters align-items-center">
                <div class="col mr-2">
                  <div
                    class="text-xs font-weight-bold text-primary text-uppercase mb-1 nav-link"
                  >
                    {{ n.tag }}
                  </div>
                  <div class="h5 mb-0 font-weight-bold text-gray-800">
                    {{ n.count }}
                  </div>
                </div>
                <div class="col-auto">
                  <i :class="`fa fa-${n.icon} fa-2x text-gray-300`"></i>
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
      <!-- card end -->
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: Array
  }
};
</script>

<style></style>
